import { render } from "./delete-account.vue?vue&type=template&id=36b4972e"
import script from "./delete-account.vue?vue&type=script&lang=js"
export * from "./delete-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__